require('./dist/angular-strap.js');
require('./dist/angular-strap.tpl.min.js');
module.exports = 'mgcrea.ngStrap';



//////////////////
// WEBPACK FOOTER
// ./~/angular-strap/index.js
// module id = 544
// module chunks = 0